"use client";

import React from "react";
import { LucideIcon } from "lucide-react";

interface SectionHeaderProps {
  title: string;
  color?: "slate" | "green" | "blue" | "purple" | "orange" | "red" | "indigo";
  icon?: LucideIcon;
  children?: React.ReactNode;
  className?: string;
}

const colorClasses = {
  slate: {
    divider: "bg-slate-300",
    title: "text-slate-900",
    icon: "text-slate-600"
  },
  green: {
    divider: "bg-green-500",
    title: "text-green-900",
    icon: "text-green-600"
  },
  blue: {
    divider: "bg-blue-500", 
    title: "text-blue-900",
    icon: "text-blue-600"
  },
  purple: {
    divider: "bg-purple-500",
    title: "text-purple-900", 
    icon: "text-purple-600"
  },
  orange: {
    divider: "bg-orange-500",
    title: "text-orange-900",
    icon: "text-orange-600"
  },
  red: {
    divider: "bg-red-500",
    title: "text-red-900",
    icon: "text-red-600"
  },
  indigo: {
    divider: "bg-indigo-500",
    title: "text-indigo-900",
    icon: "text-indigo-600"
  }
};

export function SectionHeader({ 
  title, 
  color = "slate", 
  icon: Icon,
  children,
  className = ""
}: SectionHeaderProps) {
  const colors = colorClasses[color];

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <div className={`h-1 w-8 ${colors.divider} rounded-full`}></div>
      {Icon && <Icon className={`h-5 w-5 ${colors.icon}`} />}
      <h3 className={`font-semibold text-lg ${colors.title}`}>
        {title}
      </h3>
      {children}
    </div>
  );
}
